import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "ai247-portal-header" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"ai247-portal-brand\"><img src=\"media/ai247-logo.png\" alt=\"AI 24/7 — Plug &amp; Play Software as a Service\" class=\"ai247-portal-brand__logo\"><div class=\"ai247-portal-brand__copy\"><div class=\"ai247-portal-brand__tagline\">AGG Intelligent Service</div><p class=\"ai247-portal-brand__desc\"> Your always-on CRM, marketing, and AI — capturing leads, answering inquiries, and growing your business around the clock. </p></div></div>", 1)
const _hoisted_3 = { class: "ai247-portal-header__actions" }
const _hoisted_4 = {
  class: "ai247-portal-rail-btn__icon",
  "aria-hidden": "true"
}
const _hoisted_5 = {
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_6 = {
  key: 0,
  d: "M9 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4M15 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4M10 8v8",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_7 = {
  key: 1,
  d: "M9 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4M15 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4M10 8v8M14 12h6",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_8 = {
  class: "ai247-portal-fullscreen-btn__icon",
  "aria-hidden": "true"
}
const _hoisted_9 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("path", {
  d: "M8 3H5a2 2 0 0 0-2 2v3M16 3h3a2 2 0 0 1 2 2v3M8 21H5a2 2 0 0 1-2-2v-3M16 21h3a2 2 0 0 0 2-2v-3",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_11 = {
  key: 1,
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("path", {
  d: "M9 9H5V5M15 9h4V5M9 15H5v4M15 15h4v4",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "alert alert-danger mb-4"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("span", {
  class: "ai247-instance-rail-reopen__icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("svg", {
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createVNode("path", {
      d: "M9 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4M15 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4M10 8v8M14 12h6",
      stroke: "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "ai247-instance-rail-reopen__label" }, "Instances", -1)
const _hoisted_16 = { class: "ai247-portal-main" }
const _hoisted_17 = { class: "ai247-content-inset" }
const _hoisted_18 = { class: "ai247-content-inset" }
const _hoisted_19 = { class: "ai247-content-inset" }
const _hoisted_20 = { class: "ai247-content-inset" }
const _hoisted_21 = { class: "ai247-content-inset" }
const _hoisted_22 = { class: "ai247-content-inset" }
const _hoisted_23 = { class: "ai247-content-inset" }
const _hoisted_24 = { class: "ai247-content-inset" }
const _hoisted_25 = { class: "ai247-content-inset" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_Ai247InstanceRail = _resolveComponent("Ai247InstanceRail")
  const _component_Ai247Explanation = _resolveComponent("Ai247Explanation")
  const _component_Ai247InstanceDetail = _resolveComponent("Ai247InstanceDetail")
  const _component_ProspectsList = _resolveComponent("ProspectsList")
  const _component_SocialFanoutSettings = _resolveComponent("SocialFanoutSettings")
  const _component_TeamContentPublish = _resolveComponent("TeamContentPublish")
  const _component_ContentPublishHistory = _resolveComponent("ContentPublishHistory")
  const _component_KnowledgeBases = _resolveComponent("KnowledgeBases")
  const _component_UnansweredQuestions = _resolveComponent("UnansweredQuestions")
  const _component_AiAgents = _resolveComponent("AiAgents")
  const _component_AiSettings = _resolveComponent("AiSettings")

  return (_openBlock(), _createBlock("div", null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      ref: "portalShell",
      class: ["ai247-portal-shell", { 'is-fullscreen': _ctx.isFullscreen }]
    }, [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          (_ctx.showInstanceRail)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                type: "button",
                class: "ai247-portal-rail-btn",
                "aria-label": _ctx.instanceRailOpen ? 'Hide instances panel' : 'Show instances panel',
                "aria-pressed": _ctx.instanceRailOpen,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleInstanceRail && _ctx.toggleInstanceRail(...args)))
              }, [
                _createVNode("span", _hoisted_4, [
                  (_openBlock(), _createBlock("svg", _hoisted_5, [
                    (_ctx.instanceRailOpen)
                      ? (_openBlock(), _createBlock("path", _hoisted_6))
                      : (_openBlock(), _createBlock("path", _hoisted_7))
                  ]))
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.instanceRailOpen ? "Hide instances" : "Show instances"), 1)
              ], 8, ["aria-label", "aria-pressed"]))
            : _createCommentVNode("", true),
          _createVNode("button", {
            type: "button",
            class: "ai247-portal-fullscreen-btn",
            "aria-label": _ctx.isFullscreen ? 'Exit full screen' : 'Enter full screen',
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleFullscreen && _ctx.toggleFullscreen(...args)))
          }, [
            _createVNode("span", _hoisted_8, [
              (!_ctx.isFullscreen)
                ? (_openBlock(), _createBlock("svg", _hoisted_9, [
                    _hoisted_10
                  ]))
                : (_openBlock(), _createBlock("svg", _hoisted_11, [
                    _hoisted_12
                  ]))
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.isFullscreen ? "Exit full screen" : "Full screen"), 1)
          ], 8, ["aria-label"])
        ])
      ]),
      (_ctx.loadError)
        ? (_openBlock(), _createBlock("div", _hoisted_13, _toDisplayString(_ctx.loadError), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_el_tabs, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = $event)),
        class: "ai247-portal-tabs",
        onTabChange: _ctx.onTabChange
      }, {
        default: _withCtx(() => [
          (_ctx.isSitesBuilderPreviewUser)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 0,
                label: "Sites",
                name: "sites-link"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_tab_pane, {
            label: "Overview",
            name: "overview"
          }),
          _createVNode(_component_el_tab_pane, {
            label: "Account",
            name: "portal"
          }),
          _createVNode(_component_el_tab_pane, {
            label: "Prospects",
            name: "prospects"
          }),
          _createVNode(_component_el_tab_pane, {
            label: "Social Fan-out",
            name: "social"
          }),
          _createVNode(_component_el_tab_pane, {
            label: "Publish Content",
            name: "publish"
          }),
          _createVNode(_component_el_tab_pane, {
            label: "Publish History",
            name: "history"
          }),
          _createVNode(_component_el_tab_pane, {
            label: "Knowledge Base",
            name: "knowledge-bases"
          }),
          _createVNode(_component_el_tab_pane, {
            label: "Unanswered Questions",
            name: "unanswered-questions"
          }),
          _createVNode(_component_el_tab_pane, {
            label: "AI Agents",
            name: "ai-agents"
          }),
          _createVNode(_component_el_tab_pane, {
            label: "AI Messenger Settings",
            name: "ai"
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onTabChange"]),
      _createVNode("div", {
        class: ["ai247-portal-body", { 'ai247-portal-body--rail-collapsed': _ctx.showInstanceRail && !_ctx.instanceRailOpen }]
      }, [
        _withDirectives(_createVNode(_component_Ai247InstanceRail, {
          instances: _ctx.instances,
          "pending-activation-ids": _ctx.pendingActivationIds,
          "active-instance-key": _ctx.activeInstanceKey,
          "instance-filter": _ctx.instanceFilter,
          onSelect: _ctx.selectInstance,
          onFilterChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.instanceFilter = $event)),
          onActivateAnother: _ctx.startActivateAnother,
          onCollapse: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setInstanceRailOpen(false)))
        }, null, 8, ["instances", "pending-activation-ids", "active-instance-key", "instance-filter", "onSelect", "onActivateAnother"]), [
          [_vShow, _ctx.showInstanceRail && _ctx.instanceRailOpen]
        ]),
        (_ctx.showInstanceRail && !_ctx.instanceRailOpen)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              type: "button",
              class: "ai247-instance-rail-reopen",
              "aria-label": "Show instances panel",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setInstanceRailOpen(true)))
            }, [
              _hoisted_14,
              _hoisted_15
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_16, [
          _withDirectives(_createVNode("div", _hoisted_17, [
            _createVNode(_component_Ai247Explanation, { onNavigate: _ctx.switchTab }, null, 8, ["onNavigate"])
          ], 512), [
            [_vShow, _ctx.activeTab === 'overview']
          ]),
          _withDirectives(_createVNode("div", null, [
            _createVNode(_component_Ai247InstanceDetail, {
              "active-instance-key": _ctx.activeInstanceKey,
              location: _ctx.location,
              connected: _ctx.connected,
              "pending-application": _ctx.pendingApplication,
              "status-loaded": _ctx.statusLoaded,
              subscription: _ctx.subscription,
              "trial-days-left": _ctx.trialDaysLeft,
              "show-plan-buttons": _ctx.showPlanButtons,
              submitting: _ctx.submitting,
              refreshing: _ctx.refreshing,
              subscribing: _ctx.subscribing,
              "has-pending-slots": _ctx.pendingActivationIds.length > 0,
              "can-signup": _ctx.canSignup,
              form: _ctx.form,
              countries: _ctx.countries,
              onRefresh: _ctx.refreshStatus,
              onSubmitForm: _ctx.submitForm,
              onChoosePlan: _ctx.choosePlan,
              onActivateAnother: _ctx.startActivateAnother
            }, null, 8, ["active-instance-key", "location", "connected", "pending-application", "status-loaded", "subscription", "trial-days-left", "show-plan-buttons", "submitting", "refreshing", "subscribing", "has-pending-slots", "can-signup", "form", "countries", "onRefresh", "onSubmitForm", "onChoosePlan", "onActivateAnother"])
          ], 512), [
            [_vShow, _ctx.activeTab === 'portal']
          ]),
          _withDirectives(_createVNode("div", _hoisted_18, [
            _createVNode(_component_ProspectsList, {
              key: _ctx.activeInstanceKey,
              embedded: "",
              "has-ghl-location": _ctx.connected && !!_ctx.location,
              "location-id": _ctx.location?.locationId || ''
            }, null, 8, ["has-ghl-location", "location-id"])
          ], 512), [
            [_vShow, _ctx.activeTab === 'prospects']
          ]),
          _withDirectives(_createVNode("div", _hoisted_19, [
            _createVNode(_component_SocialFanoutSettings, {
              key: _ctx.activeInstanceKey,
              embedded: ""
            })
          ], 512), [
            [_vShow, _ctx.activeTab === 'social']
          ]),
          _withDirectives(_createVNode("div", _hoisted_20, [
            _createVNode(_component_TeamContentPublish, {
              key: _ctx.activeInstanceKey,
              embedded: "",
              "campaign-id": _ctx.publishCampaignId,
              onViewHistory: _cache[7] || (_cache[7] = ($event: any) => (_ctx.switchTab('history')))
            }, null, 8, ["campaign-id"])
          ], 512), [
            [_vShow, _ctx.activeTab === 'publish']
          ]),
          _withDirectives(_createVNode("div", _hoisted_21, [
            _createVNode(_component_ContentPublishHistory, {
              key: _ctx.activeInstanceKey,
              embedded: "",
              onEditCampaign: _ctx.editCampaign
            }, null, 8, ["onEditCampaign"])
          ], 512), [
            [_vShow, _ctx.activeTab === 'history']
          ]),
          _withDirectives(_createVNode("div", _hoisted_22, [
            _createVNode(_component_KnowledgeBases, {
              key: _ctx.activeInstanceKey,
              embedded: ""
            })
          ], 512), [
            [_vShow, _ctx.activeTab === 'knowledge-bases']
          ]),
          _withDirectives(_createVNode("div", _hoisted_23, [
            _createVNode(_component_UnansweredQuestions, {
              key: _ctx.activeInstanceKey,
              embedded: "",
              onNavigate: _ctx.switchTab
            }, null, 8, ["onNavigate"])
          ], 512), [
            [_vShow, _ctx.activeTab === 'unanswered-questions']
          ]),
          _withDirectives(_createVNode("div", _hoisted_24, [
            _createVNode(_component_AiAgents, {
              key: _ctx.activeInstanceKey,
              embedded: ""
            })
          ], 512), [
            [_vShow, _ctx.activeTab === 'ai-agents']
          ]),
          _withDirectives(_createVNode("div", _hoisted_25, [
            _createVNode(_component_AiSettings, {
              key: _ctx.activeInstanceKey,
              "has-ghl-location": _ctx.connected && !!_ctx.location,
              "location-id": _ctx.location?.locationId || ''
            }, null, 8, ["has-ghl-location", "location-id"])
          ], 512), [
            [_vShow, _ctx.activeTab === 'ai']
          ])
        ])
      ], 2)
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ]))
}